import React from "react";

function Error(props) {
    return (
        <section class="h-full ">
            <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6 h-full flex items-center ">
                <div class="mx-auto max-w-screen-sm text-center">
                    <h1 class="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-primary-600 text-peach ">
                        404
                    </h1>
                    <p class="mb-4 text-3xl tracking-tight font-bold text-peachBlack dark:text-white font-fredoka">
                        Something's missing.
                    </p>
                    <p class="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">
                        Sorry, we can't find that page. You'll find lots to
                        explore on the home page.{" "}
                    </p>
                </div>
            </div>
        </section>
    );
}

export default Error;
